import React, { Component, Fragment } from 'react'
import { dateFormat, dateVal, moneyInline, numVal, strVal } from '../../../../modules/Utils'
import { Col } from 'antd'
import { get } from 'lodash'
import IconText from '../../../../elements/IconText'
import moment from 'moment'

class AccountDetails extends Component {
  render() {
    const { account, style, onShowStatement, onShowTransaction } = this.props
    let accountBalanceSrc = 'lastTransaction.balance'
    if (get(account, 'lastStatement')) {
      const lastTransaction = dateVal(account, 'lastTransaction.date').valueOf() || ''
      const lastStatement = dateVal(account, 'lastStatement.date').valueOf() || ''
      const now = moment().valueOf()
      const tranNow = now - lastTransaction
      const stateNow = now - lastStatement
      accountBalanceSrc = stateNow < tranNow ? 'lastStatement.balance.closing' : accountBalanceSrc
    }
    return (
      <Fragment>
        <Col span={12}>
          <span className={style.accountDetails}>Account Balance</span>
        </Col>
        <Col span={12}>
          <span className={style.accountDetailsValue}>
            {moneyInline(numVal(account, accountBalanceSrc), strVal(account, 'bank.bank.currency'))}
          </span>
        </Col>

        {get(account, 'lastTransaction.date') && (
          <Fragment>
            <Col span={12}>
              <span className={style.accountDetails}>Last Transaction Date</span>
            </Col>
            <Col span={12}>
              <a
                onClick={() => onShowTransaction(get(account, 'lastTransaction'))}
                className={style.accountDetailsValue}>
                <IconText
                  type={'arrows-alt'}
                  position={'left'}
                  text={dateFormat(dateVal(account, 'lastTransaction.date'))}
                />
              </a>
            </Col>
          </Fragment>
        )}

        {get(account, 'lastStatement') && (
          <Fragment>
            <Col span={12}>
              <span className={style.accountDetails}>Last Statement Closing</span>
            </Col>
            <Col span={12}>
              <a
                onClick={() => onShowStatement(get(account, 'lastStatement'))}
                className={style.accountDetailsValue}>
                <IconText
                  type={'arrows-alt'}
                  position={'left'}
                  text={moneyInline(
                    numVal(account, 'lastStatement.balance.closing'),
                    strVal(account, 'bank.bank.currency'),
                  )}
                />
              </a>
            </Col>
          </Fragment>
        )}

        {get(account, 'lastStatement.period.end') && (
          <Fragment>
            <Col span={12}>
              <span className={style.accountDetails}>Last Statement End</span>
            </Col>
            <Col span={12}>
              <span className={style.accountDetailsValue}>
                {dateFormat(dateVal(account, 'lastStatement.date'))}
              </span>
            </Col>
          </Fragment>
        )}

        {numVal(account, 'unallocated') === 0 ? (
          <Col span={12} offset={12}>
            <IconText
              style={{ fontSize: 16, color: '#31cc46' }}
              type={'check'}
              text={'Reconciled'}
            />
          </Col>
        ) : (
          <Fragment>
            <Col span={12}>
              <span className={style.accountDetails}>Unallocated Transactions</span>
            </Col>
            <Col span={12}>
              <span className={style.accountDetailsValue}>{`${numVal(
                account,
                'unallocated',
              )} of ${numVal(account, 'totalTransactions')} `}</span>
            </Col>
          </Fragment>
        )}
      </Fragment>
    )
  }
}

AccountDetails.propTypes = {}
AccountDetails.defaultProps = {}

export default AccountDetails
